// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__5wp44","label":"styles_label__O8J1R","img":"styles_img__xyJps"};